import { useEffect, useState } from "react";
import Head from "next/head";
import Layout from "layout/Layout/index.js";
import Image from "next/image";
import SSS from "components/SSS/SSS";
import EmailServices from "@/components/CorporateEmail/EmailServices";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getCurrencyRates, getMailServerList } from "services/allServices";
import { useGlobalStore } from "store/GlobalStore";
import { useTranslation } from "next-i18next";
import { changeCurrency } from "helpers/helpersFunc";
import Button from "@/components/FormElements/Button";
import { useRouter } from "next/router";
import { useConfigurationStore } from "store/ConfigurationStore";
import SSSData from "public/SSS/sss-tr-kurumsal-eposta.json";
import SSSDataEN from "public/SSS/sss-en-kurumsal-eposta.json";
import { googleEventConfiguration } from "helpers/googleEvents";
import DidntFindForm from "@/components/PhysicalServers/DidntFindForm";
import WhatIsCorporateEmail from "@/components/CorporateEmail/WhatIsCorporateEmail";
import EasyAndFastMailManagement from "@/components/CorporateEmail/EasyAndFastMailManagement";
import EasyManagementAndUserAddingAdvantages from "@/components/CorporateEmail/EasyManagementAndUserAddingAdvantages";
import FastInstallationAnd247TechnicalSupport from "@/components/CorporateEmail/FastInstallationAnd247TechnicalSupport";
import UninterruptedSupportWithMakdos from "@/components/CorporateEmail/UninterruptedSupportWithMakdos";
import ProfessionalAlternativeMakdosMailHosting from "@/components/CorporateEmail/ProfessionalAlternativeMakdosMailHosting";

function corporateemail({ datas, rates }) {
  const { t } = useTranslation(["common", "email"]);
  const [mailServerList, setMailServerList] = useState([]);
  const [setCurrencyRates, currencyRates, currencyType] = useGlobalStore((state) => [state.setCurrencyRates, state.currencyRates, state.currencyType]);
  const [setSelectedServer, clearAllConfigurations, setConfigurationType] = useConfigurationStore((state) => [state.setSelectedServer, state.clearAllConfigurations, state.setConfigurationType]);
  const router = useRouter();
  const onGetMailServerList = () => {
    setMailServerList(datas);
  };

  const calculatePrice = (p) => {
    let newPrice = changeCurrency(currencyRates, currencyType, parseFloat(p?.toFixed(2)));
    let price = newPrice;
    let splitedPrice = price.split(".");
    return splitedPrice;
  };

  const goConfigurations = (id) => {
    clearAllConfigurations();

    googleEventConfiguration(mailServerList[0], mailServerList[0].one_month_price, mailServerList[0].currency, "product_page");
    setSelectedServer(id);
    setConfigurationType("mail");
    router.push(t("nav:configuration"));
  };

  useEffect(() => {
    onGetMailServerList();
  }, []);

  useEffect(() => {
    setCurrencyRates(rates);
  }, [rates]);

  return (
    <Layout>
      <Head>
        <title>{t('emailMetaTitle')}</title>
        <meta name="description" content={t('emailMetaDescription')} />
        <meta property="og:title" content={t('emailMetaTitle')} key="title" />
        <meta property="og:description" content={t('emailMetaDescription')} key="description" />
      </Head>
      <div className="w-full">
        <div className="bg-no-repeat bg-emailBg">
          <div className="container px-4 pt-20 pb-20 mx-auto lg:px-0">
            <div className="flex items-center justify-between mb-14">
              <div>
                <p className="text-xl">{t("email:title")}</p>
                <h1 className="my-3 text-5xl font-semibold">{t("email:title2")}</h1>
                <div className="lg:w-[800px]" dangerouslySetInnerHTML={{ __html: t("email:description") }}></div>
              </div>
              <div className="hidden lg:flex">
                {router.locale === "tr" ?
                  <Image
                    src="/corparateEmail.svg"
                    alt="email"
                    title="E-Mail"
                    width="313"
                    height="110"
                    priority
                    loading="eager"
                    className="transform-gpu"
                  />
                  :
                  <Image
                    src="/corparateEmailEN.svg"
                    alt="email"
                    title="E-Mail"
                    width="313"
                    height="110"
                    priority
                    loading="eager"
                    className="transform-gpu"
                  />
                }
              </div>
            </div>

            {mailServerList && mailServerList.length > 0 &&
              <div className="grid grid-cols-2 gap-8">
                <div className="col-span-2 p-5 bg-white rounded-md shadow-md lg:col-span-1">
                  <p className="text-3xl font-semibold">{mailServerList[0]?.product_name}</p>
                  <div className="grid grid-cols-3 gap-6 mt-6 lg:grid-cols-4">
                    <div className="col-span-1">
                      <p className="emailSize">{t('e-mail')}</p>
                      <p className="text-lg font-semibold lg:text-2xl">{mailServerList[0]?.email_number} {t('unit')}</p>
                    </div>
                    <div className="col-span-1">
                      <p className="temailSize">Firewall</p>
                      <p className="text-lg font-semibold lg:text-2xl">{mailServerList[0]?.has_firewall ? t('available') : t('not-available')}</p>
                    </div>
                    <div className="col-span-1">
                      <p className="emailSize">Disk</p>
                      <p
                        className="text-lg font-semibold lg:text-2xl">{mailServerList[0]?.disk.disk_size + " " + mailServerList[0]?.disk.disk_unit}</p>
                    </div>
                    <div className="hidden lg:block" />
                    <div className="col-span-1">
                      <p className="emailSize">{t('spam-filter')}</p>
                      <p className="text-lg font-semibold lg:text-2xl">{mailServerList[0]?.has_spam_filter ? t('available') : t('not-available')}</p>
                    </div>
                    <div className="col-span-1">
                      <p className="emailSize">Backup</p>
                      <p className="text-lg font-semibold lg:text-2xl">{router.locale === "tr" ? mailServerList[0]?.backup : "Daily"}</p>
                    </div>
                    <div className="col-span-1">
                      <p className="emailSize">IP</p>
                      <p className="text-lg font-semibold lg:text-2xl">{mailServerList[0]?.ip_address === "/32" ? ("1 " + t('unit')) : mailServerList[0]?.ip_address}</p>
                    </div>
                  </div>

                  <div className="flex items-center justify-between p-3 mt-3 rounded-md bg-[#F1F5F9]">
                    <div className="flex items-center">
                      <div className="flex">
                        <p
                          className="text-3xl font-semibold text-titleColor">{calculatePrice(mailServerList[0]?.one_month_price)[0]}.</p>
                        <div className="flex flex-col ml-1">
                          <span
                            className="p-0 m-0 text-sm font-semibold text-titleColor">{calculatePrice(mailServerList[0]?.one_month_price)[1]} {currencyType}</span>
                          <span className="p-0 m-0 text-xs text-titleColor">{t("common:monthly")} + {t('extra')}</span>
                        </div>
                      </div>
                      <p className="ml-4"> {t('startingPrice')}</p>
                    </div>
                    <Button onClick={() => goConfigurations(mailServerList[0]?.id)} name={mailServerList[0]?.id}
                      buttonText={t("common:configure")} buttonLeftIcon="ri-tools-fill" />
                  </div>
                </div>

                <div className="z-10 grid col-span-2 p-5 overflow-hidden bg-white rounded-md shadow-md lg:grid-cols-5 lg:relative lg:col-span-1">
                  <div className="flex flex-col justify-center lg:col-span-3">
                    <p className="text-2xl font-semibold text-makdosTitleDiv">{t("email:boxHeading")}</p>
                    <p className="mt-3 text-cardText">{t("email:boxParagraph")}</p>
                  </div>
                  <div className="ml-5 lg:ml-0 lg:col-span-2 lg:absolute lg:-right-2 lg:-bottom-1">
                    <Image src="/kurumsal-email.svg" alt="mailbox" title="mailbox" width="270" height="270" />
                  </div>
                </div>
              </div>
            }
            <div className="grid grid-cols-2 mt-20 lg:gap-6">
              <div className="col-span-2 lg:col-span-1">
                <Image src="/emailImage.png" alt="email" title="Email" width="628" height="392" />
              </div>
              <div className="flex items-center col-span-2 lg:col-span-1">
                <div className="flex flex-col justify-center pr-9">
                  <h2 className="mb-1 text-4xl font-semibold text-titleColor">{t("email:paragraphTitle")}</h2>
                  <h2 className="mb-5 text-4xl font-semibold text-titleColor">{t("email:paragraphTitle2")}</h2>
                  <div className="text-sm text-textGray" dangerouslySetInnerHTML={{ __html: t("email:paragraph") }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <EmailServices />

        <WhatIsCorporateEmail />

        <EasyAndFastMailManagement />

        <EasyManagementAndUserAddingAdvantages />

        <FastInstallationAnd247TechnicalSupport />

        <ProfessionalAlternativeMakdosMailHosting />

        <UninterruptedSupportWithMakdos />
      </div>
      <div className="mt-20">
        <SSS data={router.locale === "tr" ? SSSData : SSSDataEN} />
      </div>

      <DidntFindForm eposta={true} />
    </Layout>

  );
}

export default corporateemail;

export const getServerSideProps = async ({ locale }) => {
  let datas = {};
  await getMailServerList().then(res => {
    res[0].group_group = {
      ...res[0].group_group, item_category_dict: {
        item_category: 'Extra',
        item_category2: 'Mail',
        item_category3: 'Makdos Mail'
      }
    }
    datas = res;
  });
  let rates = {};
  await getCurrencyRates().then(res => {
    rates = res;
  });

  return {
    props: {
      ...await serverSideTranslations(locale, ["common", "nav", "email"]),
      datas: datas,
      rates: rates
    }
  };
};